// © 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
//
// Nothing here (M3-37).
//
// A 404 that offers the thing the visitor probably wanted. Most paths that reach this are either
// a typo or a link to a destination that has not been built yet, and in both cases the useful
// answer is a ball in play rather than an apology.

import { Link, useLocation } from 'react-router'
import { unavailableReason } from '../routes'
import { useLocalisation } from '../i18n/useLanguage'

export function NotFound(): React.JSX.Element {
  const { t } = useLocalisation()
  const { pathname } = useLocation()
  // A destination the design has a seat for but no code behind yet says so plainly, rather than
  // pretending the address was wrong.
  const waiting = unavailableReason(pathname)

  return (
    <div className="page">
      <h1>{waiting === undefined ? t('notfound.heading') : waiting}</h1>
      <p className="page__lede">
        {waiting === undefined
          ? `There is no page at ${pathname}.`
          : t('notfound.on-the-way')}
      </p>
      <Link className="button button--primary" to="/" title={t('notfound.play-title')}>
        ▸ PLAY NEON NOVA
      </Link>
      {/*
        The second answer to "there is nothing here" (M10-25).

        `Arcade.tsx` wrote the argument for the build card and it is a sentence about a dead end
        rather than about a roster: *"you look for a machine, you do not find it, you make one."*
        This page is that dead end — a mistyped address, or a link to something that was never
        published — and it offered one door.

        Second, never first. A ball in play is what most people who land here wanted, and 08 §1's
        rule that the machine comes before any explanation does not stop applying on a 404.
      */}
      <Link className="button" to="/builder" title={t('builder.open-title')}>
        {t('builder.open')}
      </Link>
    </div>
  )
}
